import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Dialog } from "@headlessui/react";
import { FaUserLock } from "react-icons/fa";

const LoginPromptModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLoginRedirect = () => {
    onClose();
    navigate("/login", {
      state: { from: location.pathname }, // ✅ Pass current page
    });
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      className="fixed z-50 inset-0 flex items-center justify-center"
    >
      <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm" />
      <Dialog.Panel className="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-6 z-50 relative transform transition-all duration-300 scale-100">
        <div className="flex flex-col items-center text-center">
          <FaUserLock className="text-primary text-5xl mb-4" />
          <Dialog.Title className="text-2xl font-semibold text-text-muted mb-2">
            Login Required
          </Dialog.Title>
          <Dialog.Description className="text-sm text-gray-500 mb-6">
            You must be logged in to access this feature.
          </Dialog.Description>

          <div className="flex gap-4">
            <button
              onClick={onClose}
              className="px-5 py-2 bg-gray-200 text-text-muted rounded-lg hover:bg-gray-300 transition"
            >
              Cancel
            </button>
            <button
              type="button" // 👈 ADD THIS LINE
              onClick={handleLoginRedirect}
              className="px-5 py-2 bg-primary text-white rounded-lg shadow-md hover:bg-primary-shade4 transition-all"
            >
              Go to Login
            </button>
          </div>
        </div>
      </Dialog.Panel>
    </Dialog>
  );
};

export default LoginPromptModal;
